export const COLUMN_INDICATOR_HEIGHT = 12;
export const COLUMN_INDICATOR_ADJUSTMENT = `${COLUMN_INDICATOR_HEIGHT}px`;
export const NATIVE_SCROLL_BOTTOM_GUTTER = COLUMN_INDICATOR_HEIGHT * 2;

export const FIRST_ROWS = [1, 2, 3];

export const prependClassname = (prefix: string, className: string) => {
  if (prefix) {
    return `${prefix}-${className}`;
  }

  return className;
};
